import { toast } from 'react-toastify';

/**
 * Wrapper for toast.error, kept for the call sites that already use it.
 *
 * Logging is no longer done here: `installToastErrorLogging` subscribes to the
 * toast stream itself, so every error toast is logged whether it goes through
 * this helper or calls `toast.error` directly.
 *
 * @param {string} message - The error message to display
 * @param {object} options - Toast options (optional)
 * @returns {number|string} Toast ID
 */
export const errorToast = (message, options) => toast.error(message, options);

export default errorToast;
